import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from 'content-management-details-lib/providers/ContentDetailsDataProvider';
import { useMemo } from 'react';
const useAnalyticsPageId = () => {
  const {
    contentObject,
    contentId
  } = useContentDetailsDataProvider();
  const analyticsPageId = useMemo(() => {
    const analyticsPageIdStr = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ANALYTICS_PAGE_ID);
    return analyticsPageIdStr || `${contentId}`;
  }, [contentObject, contentId]);
  return analyticsPageId;
};
export default useAnalyticsPageId;